import { render, staticRenderFns } from "./AutomationsRuleAttribute.vue?vue&type=template&id=9a458524&scoped=true&"
import script from "./AutomationsRuleAttribute.vue?vue&type=script&lang=js&"
export * from "./AutomationsRuleAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsRuleAttribute.vue?vue&type=style&index=0&id=9a458524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a458524",
  null
  
)

export default component.exports